import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';
import { Heading } from '../Heading';
import { Icon } from '../Icon';
import { Paragraph } from '../Paragraph';
import { Header } from '../SideNavigation/Header';

export const StyledContainer = styled('div')`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    ${({ theme }) => `
        gap: ${theme.tggSpacing(6)};
        padding: ${theme.tggSpacing(6)};

        ${theme.breakpoints.up('desktop')} {
            padding-top: ${theme.tggSpacing(8)};
            gap: ${theme.tggSpacing(8)};
        }
    `}
`;

export const StyledParagraph = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => `
        ${theme.breakpoints.up('desktop')} {
        margin-top: ${theme.tggSpacing(rem(1), 2.5)};
    }
	`}
`;

export const StyledGymBagHeader = styled(Header)`
    ${({ theme }) => `
        margin-bottom: 0;
        padding: ${theme.tggSpacing([6, 6, 0, 6])};

        ${theme.breakpoints.up('desktop')} {
            margin-bottom: 0;
        }
     `};
`;

export const StyledIntroductionHeading = styled(Heading)`
    ${({ theme }) => theme.typography.h4Rebrand};
    margin-bottom: 0.4rem;
    color: ${({ theme }) => theme.palette.tgg.text.body.main};
`;

export const StyledIntroductionParagraph = styled('span')`
    ${({ theme }) => theme.typography.bodySmallRebrand};
    color: ${({ theme }) => theme.palette.tgg.text.body.main};
`;

export const StyledFindAGymLink = styled('a')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: ${theme.tggSpacing(rem(1), 2.5)};
        margin: ${theme.tggSpacing([rem(2.8), 0], [11, 0])};
        font-family: 'thegymgroupsans-Headline';
        color: ${theme.palette.common.white};
        text-decoration: none;
        background-color: ${theme.palette.primary.main};
        border-radius: ${theme.tggSpacing(rem(1), 2.5)};

        &:hover {
            background-color: ${theme.palette.primary.dark};
        }

        &:focus {
            background-color: ${theme.palette.primary.main};
            outline: solid ${theme.tggSpacing(rem(0.2), 0.5)}
                ${theme.palette.primary.main};
            outline-offset: ${theme.tggSpacing(rem(0.2), 0.5)};
        }

        &:active {
            background-color: ${theme.palette.other.actionBlue};
            outline: none;
        }
	`}
`;

export const StyledPaymentIcons = styled('ul')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: ${theme.tggSpacing(0, 0)};

        li {
            list-style: none;
        }

        svg {
            height: ${theme.tggSpacing(rem(2), 5)};
        }

        rect {
            stroke: none;
        }
	`}
`;

export const StyledNavigationList = styled('ul')`
    ${({ theme }: { theme: Theme }) => `
        padding-left: ${theme.tggSpacing(0, 0)};
        margin-bottom: ${theme.tggSpacing(rem(3.5), 8.75)};

        li {
            list-style: none;
        }

        li + li {
            margin-top: ${theme.tggSpacing(rem(0.8), 3)};
        }
	`}
`;

export const StyledNavigationLink = styled('a')`
    ${({ theme }: { theme: Theme }) => theme.typography.text_16_bold_lh_24};
    ${({ theme }: { theme: Theme }) => `
        display: block;
        padding: ${theme.tggSpacing([rem(1.3), rem(2)], [5, 5])};
        color: ${theme.palette.common.blue};
        text-decoration: none;
        background-color: ${theme.palette.grey['900']};
        border-radius: ${theme.tggSpacing(rem(1), 2.5)};

        &:hover {
            background-color: ${theme.palette.other.paleBlue};
        }

        &:focus {
            background-color: ${theme.palette.grey['900']};
            outline: solid ${theme.tggSpacing(rem(0.2), 1)}
                ${theme.palette.common.blue};
            outline-offset: ${theme.tggSpacing(rem(0.2), 1)};
        }

        &:active {
            background-color: ${theme.palette.other.neutralBlue};
            outline: none;
        }
	`}
`;

export const StyledFindAGymIcon = styled(Icon)`
    ${({ theme }: { theme: Theme }) => `
        margin-bottom: ${theme.tggSpacing(rem(0.4), 1)};
	`}
`;

export const StyledHeading = styled(Heading)`
    && {
        ${({ theme }: { theme: Theme }) => `
            padding-left: ${theme.tggSpacing(0, 0)};
            margin-bottom: ${theme.tggSpacing(rem(1), 2.5)};
        `}
        ${({ theme }: { theme: Theme }) => theme.typography.bodySmallBold}
    }
`;

export const StyledBenefits = styled('ul')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        gap: ${theme.tggSpacing(rem(1.2), 5)};
        padding-left: 0;
        margin-bottom: 0;
    `}
`;

export const StyledBenefitItem = styled('li')`
    ${({ theme }: { theme: Theme }) => theme.typography.text_14};
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex: 1 1 0;
        flex-direction: column;
        gap: ${theme.tggSpacing(rem(0.5), 1.25)};
        align-items: center;
        justify-content: space-between;
        padding: ${theme.tggSpacing([0, rem(1.5)], [0, 3.75])};
        text-align: center;
        list-style: none;
	`}
`;

export const StyledGymBagFooter = styled('div')`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }: { theme: Theme }) => theme.tggSpacing(4)};
    padding: ${({ theme }: { theme: Theme }) => theme.tggSpacing(6)};
    background-color: ${({ theme }: { theme: Theme }) =>
        theme.palette.grey[100]};
`;

export const StyledTotalCost = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const StyledTotalCostText = styled('div')`
    ${({ theme }: { theme: Theme }) => theme.typography.text_16_bold};
    color: ${({ theme }: { theme: Theme }) => theme.palette.tgg.text.body.main};
`;

export const StyledNavigationButtonWrapper = styled('div')`
    > div {
        ${({ theme }: { theme: Theme }) => `
            padding: 0;
        `}

        a {
            ${({ theme }: { theme: Theme }) => theme.typography.text_16};
        }
    }
`;

export const StyledPayPalWrapper = styled('div')`
    > div {
        margin: 0;
    }
`;
